<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Row for Freedom: Crossing an Ocean In Search of Hope</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1"><a id="page1"></a><a href="#/contents#tt1" id="iw1">PART 1</a></p>
<p class="ct2"><a href="#/contents#tt1"><b>BEGINNING</b></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?7c5e8a02